import React, { useContext } from 'react';
import { UserContext } from '../contexts/UserContext';
import { useLocation, useNavigate } from 'react-router-dom';
import { Storefront, Person, Home, Pets, Search, SupportAgent, LocalShipping } from '@mui/icons-material';
import { BottomNavigation, BottomNavigationAction, Box } from '@mui/material';

function Navbar() {
  const { currentUser } = useContext(UserContext);
  const navigate = useNavigate();
  const location = useLocation();

  const activeLink = (link) => {
    return location.pathname.includes(link);
  };

  return (
    <Box pt={8}>
      <BottomNavigation
        showLabels
        sx={{
          width: '100%',
          position: 'fixed',
          bottom: 0,
          left: 0,
          zIndex: 9999,
          opacity: 0.9,
          borderTop: '1px solid #ddd',
          backgroundColor: 'white',
          overflowX: 'auto', 
          whiteSpace: 'nowrap',
          '& .MuiBottomNavigation-root': {
            display: 'flex',
            flexWrap: 'nowrap',
          },
          '& .MuiBottomNavigationAction-root': {
            whiteSpace: 'normal',
          },
          // Escondendo a scrollbar
          scrollbarWidth: 'none', // Firefox
          msOverflowStyle: 'none', // IE e Edge
          '&::-webkit-scrollbar': {
            display: 'none', // Chrome, Safari, etc.
          },
        }}
        onChange={(event, newValue) => {
          navigate(`/${newValue}`);
        }}
      >
        <BottomNavigationAction
          key="home"
          label="Home"
          value="home"
          icon={<Home />}
          sx={{ color: activeLink("home") ? "#f59723" : "primary", minWidth: '0', padding: '6px 6px' }}
        />
        <BottomNavigationAction
          key="search"
          label="Buscar"
          value="search"
          icon={<Search />}
          sx={{ color: activeLink("search") ? "#f59723" : "primary", minWidth: '0', padding: '6px 6px' }}
        />
        <BottomNavigationAction
          key="mypets"
          label="Meus Pets"
          value="mypets"
          icon={<Pets />}
          sx={{ color: activeLink("mypets") ? "#f59723" : "primary", minWidth: '0', padding: '6px 6px' }}
        />
        {currentUser?.courier_id && (
          <BottomNavigationAction
            key="delivery"
            label="Entregador"
            value="delivery-dashboard"
            icon={<LocalShipping />}
            sx={{ color: activeLink("delivery-dashboard") ? "#f59723" : "primary", minWidth: '0', padding: '6px 6px' }}
          />
        )}
        {currentUser?.provider_id && (
          <BottomNavigationAction
            key="provider"
            label="Fornecedor"
            value="provider-dashboard"
            icon={<Storefront />}
            sx={{ color: activeLink("provider-dashboard") ? "#f59723" : "primary", minWidth: '0', padding: '6px 6px' }}
          />
        )}
        {currentUser?.role === "admin" && (
          <BottomNavigationAction
            key="control-center"
            label="Centro de Controle"
            value="control-center"
            icon={<SupportAgent />}
            sx={{ color: activeLink("control-center") ? "#f59723" : "primary", minWidth: '0', padding: '6px 6px' }}
          />
        )}
        <BottomNavigationAction
          key="profile"
          label="Perfil"
          value="profile"
          icon={<Person />}
          sx={{ color: activeLink("profile") ? "#f59723" : "primary", minWidth: '0', padding: '6px 6px' }}
        />
      </BottomNavigation>
    </Box>
  );
}

export default Navbar;
